<template>
  <w-frame-popup-content-template>
    <div slot="content">
      <w-tool-tabs class="tab-button" style="height:100%;" v-model="currentActiveTab">
        <el-tab-pane label="이벤트 알람" name="eventAlarm">
          <w-event-alarm-setting-view :active-sub-tab="currentActiveTab" :is-alarm-lock="isAlarmLock" @release-alarm-lock="releaseAlarmLock" ref="eventAlarmSettingView" />
        </el-tab-pane>
        <el-tab-pane label="푸시 알림" name="pushNotification">
          <w-push-notification-setting-view :active-sub-tab="currentActiveTab" ref="pushNotificationSettingView"/>
        </el-tab-pane>
      </w-tool-tabs>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" type="solid" size="large" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="onCancelButtonClick">취소</el-button>
    </el-row>
  </w-frame-popup-content-template>
</template>

<script>
import WFramePopupContentTemplate from './FramePopupContentTemplate';
import WEventAlarmSettingView from './EventAlarmSettingView';
import WPushNotificationSettingView from './PushNotificationSettingView';

export default {
  name: 'WAlarmSettingView',
  components: {
    WFramePopupContentTemplate,
    WEventAlarmSettingView,
    WPushNotificationSettingView,
  },
  props: {
    activeTab: {
      type: String,
    },
    isAlarmLock: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentActiveTab: '',
    };
  },
  watch: {
    activeTab(activeTab) {
      if (activeTab === 'alarmSetting') {
        this.loadData();
      }
    },
  },
  methods: {
    loadData() {
      this.currentActiveTab = 'eventAlarm';
    },
    releaseAlarmLock() {
      this.$emit('release-alarm-lock');
    },
    onSaveButtonClick() {
      if (this.currentActiveTab === 'eventAlarm') {
        this.$refs.eventAlarmSettingView.setAlarmData();
      } else {
        this.$refs.pushNotificationSettingView.setPushNotificationReceiveData();
      }
    },
    onCancelButtonClick() {
      this.$emit('onCancelPopup');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/frame/components/popup/AlarmSettingView.vue